module.exports = __webpack_public_path__ + "static/media/logo_qualdo-rix-light.6e2d4250.svg";